var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHypedropSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 6,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m41.30699,0.456zm-35.838,1.887l0,-1.763l1.89,0l0,2.382l-0.584,0l0,2.381l-1.89,0l0,-1.84l-1.87,0l0,1.84l-1.89,0l0,-2.38l0.583,0l0,-2.383l1.89,0l0,1.762l1.87,0l0.001,0.001zm20.346",
    fill: "white",
    fillRule: "evenodd",
    stroke: "null"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "white",
    stroke: "null",
    strokeWidth: "null",
    strokeOpacity: "null",
    fillOpacity: "null",
    opacity: 0.5,
    d: "m18.65625,0.02832",
    id: "svg_3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m23.8695,0.456zm-35.838,1.887l0,-1.763l1.89,0l0,2.382l-0.584,0l0,2.381l-1.89,0l0,-1.84l-1.87,0l0,1.84l-1.89,0l0,-2.38l0.583,0l0,-2.383l1.89,0l0,1.762l1.87,0l0.001,0.001zm20.346,-1.763l2.406,0c1.324,0 2.181,0.126 2.797,0.786c0.317,0.343 0.537,0.902 0.545,1.596l-0.582,0l0.001,0.04c0,0.699 -0.217,1.378 -0.609,1.708c-0.528,0.448 -1.026,0.633 -2.412,0.633l-2.729,0l0,-2.38l0.583,0l0,-2.383zm1.307,2.383l0,1.3l0.522,0c0.858,0 1.374,-0.41 1.374,-1.3l0.583,0c0,-0.89 -0.516,-1.3 -1.374,-1.3l-0.522,0l0,1.3l-0.583,0z",
    fill: "white",
    fillRule: "evenodd",
    stroke: "null"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHypedropSmall);
export default __webpack_public_path__ + "static/media/hypedrop_small.82eb4a62fb390e543cf65416b760e8a5.svg";
export { ForwardRef as ReactComponent };